<template>
    <div class="select-date">
        <div class="select-date__input">
            <input @click="open = !open" readonly type="text" v-model="valueLocal" />
        </div>
        <div class="select-date__dropdown" v-if="open">
            <div class="select-date__dropdown-wrapper">
                <div
                    :class="['select-date__dropdown-item', { '_disabled': index === 0 && !isAvailableToday }]"
                    :key="index"
                    @click="chooseDate(date)"
                    v-for="(date, index) in dateArray"
                >
                    {{ customFormatter(date) }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import 'moment/locale/ru';

moment.locale('ru');

export default {
    name: 'SelectDate',
    props: {
        value: {type: Date},
        disabled: {type: Boolean, default: false},
        maxDates: {
            type: Number,
            default: 10,
        },
        orderTimeLimit: {
            type: Array,
            default() {
                return []
            }
        },
        isAvailableToday: {
            type: Boolean,
            default: true
        }
    },
    data: () => ({
        searchQuery: null,
        open: false,
        valueLocal: '',
        dateArray: [],
    }),
    methods: {
        generateDate(index) {
            return new Date(new Date().setDate(new Date().getDate() + index));
        },
        customFormatter(date) {
            const diff = moment(0, 'HH').diff(date, 'days');
            if (diff == 0) {
                return moment(date).format('[сегодня,] DD MMMM');
            } else if (diff == -1) {
                return moment(date).format('[завтра,] DD MMMM');
            }
            return moment(date).format('dddd, DD MMMM');
        },
        chooseDate(date) {
            this.open = false;
            this.$emit('input', date)
            this.valueLocal = this.customFormatter(date);
        }
    },
    computed: {
        acceptMimes() {
            return this.fileAccept ? this.fileAccept.join(', ') : '';
        },
    },
    mounted() {
        for (let i = 0; i < this.maxDates; i++) {
            this.dateArray.push(this.generateDate(i));
        }
        this.chooseDate(this.dateArray[this.isAvailableToday ? 0 : 1]);
    },
};
</script>
<style lang="scss">
@import "../../scss/base/include";

$b: '.select-date';

#{$b} {
    height: 100%;
    width: 100%;

    &__input {
        height: 100%;
        display: flex;
        align-items: center;

        input {
            cursor: pointer;
            background: right 0 center url('/local/templates/pnd/src/assets/i2/select-date.svg') no-repeat;
            padding: 0;
        }
    }

    &__dropdown {
        background-color: $white-true;
        border: 1px solid rgba(125, 121, 135, 0.2);
        border-radius: 5px;
        padding: 20px 0;
        position: absolute;
        width: 100%;
        margin-top: 17px;
        z-index: 10;
        box-shadow: 10px 14px 50px rgba(229, 233, 246, 0.8);
        max-height: 340px;
        display: flex;
        left: 0;

        &::before {
            content: '';
            position: absolute;
            width: 17px;
            height: 17px;
            border-top: 1px solid rgba(125, 121, 135, 0.2);
            border-left: 1px solid rgba(125, 121, 135, 0.2);
            transform: rotate(45deg);
            background-color: $white-true;
            top: -10px;
            left: 22px;
        }

        &-wrapper {
            overflow: auto;
            width: 100%;
        }

        &-item {
            padding: 10px 20px;
            font-size: 16px;
            line-height: 18px;
            cursor: pointer;

            &:hover {
                color: $accent;
            }

            &._disabled {
                color: rgba(125, 121, 135, 0.4);
                background-color: #EAEAEA;
                pointer-events: none;
            }
        }
    }
}
</style>
